export function isEmptyString(url?: string) {
  if (url == null) return true;

  return url.trim().length === 0;
}
